import {NotificationsDialogContext} from '@common/notifications/notifications-dialog';
import {LinkButton} from '@shadcn/button/button';
import {Empty} from '@shadcn/empty/empty';
import {Trans} from '@ui/i18n/trans';
import {useSettings} from '@ui/settings/use-settings';
import {BellIcon} from 'lucide-react';
import {use} from 'react';

type Props = {
  settingsLink?: string | null;
  className?: string;
};
export function NotificationEmptyState({settingsLink, className}: Props) {
  const {notif} = useSettings();
  const ctx = use(NotificationsDialogContext);
  return (
    <Empty.Root className={className}>
      <Empty.Header>
        <Empty.Media variant="icon">
          <BellIcon />
        </Empty.Media>
        <Empty.Title>
          <Trans message="No notifications yet" />
        </Empty.Title>
        <Empty.Description>
          <Trans message="When someone shares a file, asks for access, or opens a link you sent, it will show up here instantly." />
        </Empty.Description>
      </Empty.Header>
      {notif?.subs?.integrated && (
        <Empty.Content>
          <LinkButton
            variant="outline"
            to={settingsLink || '/account-settings/notifications'}
            size="sm"
            color="primary"
            onClick={ctx ? () => ctx.setOpen(false) : undefined}
          >
            <Trans message="Notification settings" />
          </LinkButton>
        </Empty.Content>
      )}
    </Empty.Root>
  );
}
